import { render, staticRenderFns } from "./LanguageAvailable.vue?vue&type=template&id=6b3de03f&"
import script from "./LanguageAvailable.vue?vue&type=script&lang=js&"
export * from "./LanguageAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports